import dayjs from "@/lib/dayjs";
/**
 * 現在の Unix timestamp（ミリ秒）を返す
 * @returns {number} Unix timestamp（ミリ秒）
 */
export function getCurrentUnixTimeStamp() {
	return dayjs().valueOf();
}
